import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  title: {
    textTransform: 'uppercase',
    fontFamily: '"Bebas Neue"',
    fontSize: theme.spacing(4),
  },

  indicator: {
    fontSize: theme.spacing(1.5),
    cursor: 'pointer',
    margin: theme.spacing(0, 1),

    '&:hover': {
      color: theme.palette.primary.dark,
    },

    '&:last-child': {
      margin: theme.spacing(0, 2, 0, 1),
    },
  },

  active: {
    strokeWidth: theme.spacing(0.5),
    color: theme.palette.primary.dark,
    stroke: theme.palette.text.primary,
  },
}));
